// import EntityFormProvider from '@shared/components/forms/auto-form/entity-form-provider/entity-form-provider.vue';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
import TableMock from '@shared/components/mocks/table-mock/table-mock.vue';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import BookingEventCancelModal from '@bookings/components/modals/booking-event-cancel-modal.vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import Select from '@shared/components/forms/inputs/select/select.vue';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { mixins } from 'vue-class-component';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import { BookingEvent, PublicBookingEventData } from '@bookings/interfaces/booking-event';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import moment, { Moment } from 'moment';
import AuthorizationHelper from '@auth/services/authorization.helper';
import EntityFormProvider from '@shared/components/forms/auto-form/entity-form-provider/entity-form-provider';
import DrawerBookingEventForm from '@bookings/components/drawer-booking-event-form/drawer-booking-event-form.vue';
import DrawerBookingForm from '@bookings/components/drawer-booking-form/drawer-booking-form.vue';
import BookingCalendar from '../../booking-calendar/booking-calendar.vue';
import { PublicBookingFormData } from '@bookings/interfaces/booking';
import { ParsedEvent } from '@bookings/interfaces/calendar';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import Datepicker from '@shared/components/forms/inputs/datepicker/datepicker.vue';
import ExtendedFilter from '@shared/components/filters/extended-filter/extended-filter.vue';
import CustomFilterSelector from '@shared/components/filters/custom-filter-selector/custom-filter-selector.vue';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import { setProp } from '@shared/helpers/operators';
import BulkMoveToTrashModal from '@shared/components/modals/bulk-move-to-trash-modal/bulk-move-to-trash-modal.vue';
import SearchAndOrder from '@core/interfaces/bpc-search-and-order';
import SendMessageUsingTemplateMixin from '@shared/components/tables/abstract-table/send-message-using-template-mixing';
import ModulesHelper from '@core/services/modules.helper';

import BulkRecoverModal from '@shared/components/modals/bulk-recover-modal/bulk-recover-modal.vue';
import BulkEditModal from '@shared/components/modals/bulk-edit-modal/bulk-edit-modal.vue';
import BookingEventRefuseModal from '@bookings/components/booking-event-refuse-modal/booking-event-refuse-modal.vue';
import BookingEventConfirmModal from '@bookings/components/booking-event-confirm-modal/booking-event-confirm-modal.vue';
import AddPaymentModal from '@accounting/components/modals/add-payment-modal/add-payment-modal.vue';

@Component({
  name: 'bpc-booking-event-table',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-entity-table': EntityTable,
    'bpc-table-mock': TableMock,
    'bpc-page-title': BpcPageTitle,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-booking-event-cancel-modal': BookingEventCancelModal,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-select': Select,
    'bpc-std-form': StdForm,
    'bpc-std-filter': StdFilter,
    'bpc-drawer-booking-event-form': DrawerBookingEventForm,
    'bpc-drawer-booking-form': DrawerBookingForm,
    'bpc-booking-calendar': BookingCalendar,
    'bpc-datepicker': Datepicker,
    VuePerfectScrollbar,
    'bpc-extended-filter': ExtendedFilter,
    'bpc-custom-filter-selector': CustomFilterSelector,
    'bpc-drawer-modal': DrawerModal,
    'bpc-bulk-move-to-trash-modal': BulkMoveToTrashModal,
    'bpc-bulk-recover-modal': BulkRecoverModal,
    'bpc-bulk-edit-modal': BulkEditModal,
    'bpc-booking-event-refuse-modal': BookingEventRefuseModal,
    'bpc-booking-event-confirm-modal': BookingEventConfirmModal,
    'bc-add-payment-modal': AddPaymentModal,
  },
})
export default class BookingEventTable extends mixins(
  AbstractTable,
  SendMessageUsingTemplateMixin,
) {
  $refs: AbstractTable['$refs'] & {
    // resourceForm: InstanceType<typeof ResourceForm> & { saveEntity(): void };
    stdCancelForm: InstanceType<typeof StdForm> & {
      formModel: any;
      formProvider: EntityFormProvider;
    };
    stdFilter: InstanceType<typeof StdFilter> & {
      setFilterModel(filterModel): void;
    };
    tabStdFilter: InstanceType<typeof StdFilter> & {
      setFilterModel(filterModel): void;
    };
    provider: InstanceType<typeof EntityTableProvider> & {
      getEntities(): void;
      items: any[];
      searchAndOrder: SearchAndOrder;
      queryConfig: any;
      loadingURLQueryParams: boolean;
      loadingTabURLQueryParams: boolean;
      withTabFilter: boolean;
      canLoadEntities: boolean;
      firstLoadEntities: boolean;
    };
    softDeleteConfirmationModal: InstanceType<typeof ConfirmationModal> & {
      onOpenModal(id): void;
      onCloseModal(): void;
    };
    deleteConfirmationModal: InstanceType<typeof ConfirmationModal> & {
      onOpenModal(id): void;
      onCloseModal(): void;
    };
    recoverConfirmationModal: InstanceType<typeof ConfirmationModal> & {
      onOpenModal(id): void;
      onCloseModal(): void;
    };
    bulkSoftDeleteConfirmationModal: InstanceType<typeof ConfirmationModal> & {
      onOpenModal(id): void;
      onCloseModal(): void;
    };
    bulkDeleteConfirmationModal: InstanceType<typeof ConfirmationModal> & {
      onOpenModal(id): void;
      onCloseModal(): void;
    };
    bulkRecoverConfirmationModal: InstanceType<typeof ConfirmationModal> & {
      onOpenModal(id): void;
      onCloseModal(): void;
    };
    deleteMediaFileConfirmationModal: InstanceType<typeof ConfirmationModal> & {
      onOpenModal(id): void;
      onCloseModal(): void;
    };
    bulkEditModal: InstanceType<typeof BulkEditModal> & {
      saveBulkEdit(): void;
    };
  };

  @Prop(Array) readonly value: any[];
  @Prop(String) readonly title: string;
  @Prop(String) readonly subtitle: string;
  @Prop({ type: Boolean, default: true }) readonly showTableHeader: boolean;
  @Prop({ type: Boolean, default: false }) readonly isInput: boolean;
  @Prop({ type: Boolean, default: false }) readonly hideTabsFilter: boolean;
  @Prop({ type: Boolean, default: true }) readonly showTitle: boolean;
  @Prop({
    type: Array,
    default() {
      return ['configLoaded', 'paginationLoaded', 'orderLoaded', 'urlParametersLoaded'];
    },
  })
  readonly initialFlagsToCheck: string[];
  @Prop(Array) readonly filters: any[];
  @Prop({ type: String, default: 'api' }) readonly mode: string;
  @Prop(String) readonly fieldForStorage: string;
  @Prop(Number) readonly bookingId: number;
  @Prop(Number) readonly contactId: number;
  @Prop({ type: Boolean, default: false }) readonly withDraft: boolean;
  @Prop({ type: String, default: 'default' }) readonly formConfigName: string;
  @Prop({ type: String, default: null }) readonly bookingFormConfigName: string;
  @Prop({ type: String, default: null }) readonly bookingEventFormConfigName: string;
  @Prop({ type: Boolean, default: false }) readonly showActionButtonText: boolean;
  @Prop({ type: String, default: 'default-edit' }) readonly editFormConfigName: string;
  @Prop({ type: String, default: 'cancel-events' }) readonly cancelFormConfigName: string;
  @Prop({ type: Boolean, default: true }) readonly withFilters: boolean;
  @Prop({ type: Boolean, default: true }) readonly withTabFilters: boolean;
  @Prop({ type: Boolean, default: true }) readonly showArrows: boolean;
  @Prop({ type: String, default: 'w-100' }) readonly arrowGroupClass: string;
  @Prop({ type: Boolean, default: false }) readonly isProfileView: boolean;

  /**
   * Events
   */
  weeklyContactBookings: ParsedEvent[] = [];
  bookingData: PublicBookingFormData = null;
  bookingEventData: PublicBookingEventData = null;
  public entity: BookingEvent = null;
  public entityName = 'booking-event';
  public pluralEntityName = 'booking-events';
  public permissionEntityNameToUse = 'bookings';
  public selectedRowEntity = null;
  public selectedDate = new Date().toISOString().substr(0, 10);
  public checkingPrice: boolean = false;
  public bookingFormModelChanged: boolean = false;
  public filterSectorsLoaded: boolean = false;
  public showBookingDrawerSection: boolean = false;
  public showCancelBookingEventModal: boolean = false;
  public cancelBookingEventModalId = 'cancelBookingEventModal';
  public showPaymentModal: boolean = false;

  public flagsToCheckBeforeLoadEntities: string[] = null;
  public customPageActions = {
    bulkCancel: {
      activated: false,
      type: 'action',
      icon: 'ban', //'times',
      variant: 'danger',
      text: 'cancel',
      show: false,
      event: 'bulk-cancel',
      selectElements: true,
      tag: 'left',
      permissions: ['bulk_cancel'],
    },
    bulkSendMessageUsingTemplate: {
      activated: false,
      type: 'action',
      icon: 'envelope', //'times',
      variant: 'info',
      text: 'send_message_using_template',
      show: false,
      event: 'bulk-send-message-using-template',
      selectElements: true,
      tag: 'right',
      permissions: ['bulk_message'],
    },
  };

  async getAllEvents() {
    const promises = [this.getCurrentContactEvents()];
    await Promise.all(promises);
  }

  async getCurrentContactEvents() {
    if (!this.selectedDate) {
      return;
    }
    const query = {
      limit: -1,
      status: ['confirmed', 'requested'],
      contact_id: this.$authService.getContactId(),
      weekday: this.selectedDate,
      weekly: true,
      columns: [
        'id',
        'resource_id',
        'contact_id',
        'date',
        'start_time',
        'end_time',
        'center_id',
        'discipline_id',
        'is_multiplayer',
      ],
      relationFields: [
        'bookingEventMultiplayerData.number_of_players',
        'bookingEventMultiplayerData.id',
        'bookingEventMultiplayerData.booking_event_multiplayer_id',
        'resource.id',
        'resource.name',
        'discipline.id',
        'discipline.name',
      ],
      withRelations: ['resource', 'discipline', 'center', 'orders'],
    };

    const config = {
      params: query,
    };

    const res: BPCGenericApiResponse = await this.$bpcApi
      .get(`${this.$bpcApiRouteHelper.getEntityPath('booking-event')}/public-booking`, config)
      .toPromise();

    this.weeklyContactBookings = res.data.map(event => {
      return this.parseBookingEventToCalendarOwnEvent(event);
    });
  }

  parseBookingEventToCalendarOwnEvent(event: BookingEvent): ParsedEvent {
    let eventTitle = '';
    if (event.name) {
      eventTitle += event.name + '\n';
    }
    if (event.resource && event.resource['name']) {
      eventTitle += event.resource['name'] + '\n';
    }
    return {
      id: event.id,
      title: eventTitle,
      start: this.formatDateTime(event.date, event.start_time),
      end: this.formatDateTime(event.date, event.end_time),
      backgroundColor: '#00b0e1', //'#0d3a5d',
      borderColor: '#00b0e1', //'#0d3a5d',
      resourceId: `${event.resource_id}`,
      className: ['my-event', `booking-status-${event.status}`],
      resource: event.resource,
      discipline: event.discipline,
      isMultiplayer: event.is_multiplayer,
      numberOfPlayers: event.booking_event_multiplayer_data?.number_of_players,
      // display: 'background',
    };
  }
  formatDateTime(date, time): string {
    return moment(`${date} ${time}`).toISOString();
  }
  get model(): any[] {
    return this.value;
  }

  set model(val: any[]) {
    this.$emit('input', val);
  }

  beforeMount() {
    this.flagsToCheckBeforeLoadEntities = this.initialFlagsToCheck;
  }

  customOnPageAction($event: string) {
    switch ($event) {
      case 'bulk-cancel':
        this.onBulkCancel();
        break;
      case 'add-event':
        this.onAddEvent();
        break;
      case 'bulk-send-message-using-template':
        this.onBulkSendMessageUsingTemplate(this.selection);
        break;
    }
  }

  updateModel(): void {
    this.model = this.$refs?.provider?.items;
  }

  extendUpdatePageActions() {
    if (this.config) {
      for (const activatedPageAction of this.config.data.activatedPageActions) {
        if (this.customPageActions[activatedPageAction]) {
          this.customPageActions[activatedPageAction].activated = true;
        }
      }
    }

    this.customPageActions.bulkCancel.show =
      this.$refs.provider &&
      this.$refs.provider.queryConfig.params.status !== 'trash' &&
      !this.$refs.provider.queryConfig.params.onlyTrashed;

    this.customPageActions.bulkSendMessageUsingTemplate.show =
      this.$refs.provider &&
      this.$refs.provider.queryConfig.params.status !== 'trash' &&
      !this.$refs.provider.queryConfig.params.onlyTrashed &&
      this.$modulesService.hasModuleActivated(ModulesHelper.COMMUNICATIONS_MODULE_NAME);
    this.defaultPageActions.bulkSoftDelete.show = this.$authorizationService.hasPermission(
      'delete_bookings',
    );

    // Check Permissions
    for (const activatedPageAction of this.config.data.activatedPageActions) {
      if (
        this.customPageActions[activatedPageAction] &&
        this.customPageActions[activatedPageAction]['permissions']
      ) {
        const permissions = [];
        this.customPageActions[activatedPageAction]['permissions'].forEach(permissionName => {
          permissions.push(
            {
              name: AuthorizationHelper.getPermissionName(
                permissionName,
                (this.permissionEntityNameToUse
                  ? this.permissionEntityNameToUse
                  : this.pluralEntityName
                ).replace('-', '_'),
              ),
            },
            {
              name: AuthorizationHelper.getPermissionName(
                permissionName,
                (this.permissionEntityNameToUse
                  ? this.permissionEntityNameToUse
                  : this.pluralEntityName
                ).replace('-', '_'),
                true,
              ),
            },
          );
        });
        this.customPageActions[activatedPageAction][
          'activated'
        ] = this.$authorizationService.hasPermissions(permissions);
      }
    }
  }

  get pageActions() {
    return {
      ...this.customPageActions,
      ...this.defaultPageActions,
    };
  }

  public customRowActions = {
    sendMessageUsingTemplate: {
      activated: true,
      type: 'action',
      icon: 'envelope',
      show: true,
      event: 'send-message-using-template',
      text: 'send_message_using_template',
      permissions: ['send'],
    },
    payProduct: {
      activated: false,
      type: 'action',
      icon: 'credit-card',
      show: false,
      event: 'pay-product',
      text: 'pay',
      permissions: ['pay_product'],
    },
  };

  customOnRowAction($event: { event: string; item: any }) {
    switch ($event.event) {
      case 'cancel':
        this.onCancel($event.item);
        break;
      case 'send-message-using-template':
        this.onSendMessageUsingTemplate($event.item.item);
        break;
      case 'pay-product':
        this.onPayProduct($event.item.item);
        break;
    }
  }

  onPayProduct(item) {
    this.entity = item;
    this.onOpenPaymentModal(item);
  }

  onOpenPaymentModal(entity) {
    this.showPaymentModal = true;
  }

  onCloseAddpaymentModal() {
    this.showPaymentModal = false;
  }

  onPaymentCreatedCloseModal() {
    this.showPaymentModal = false;
    this.$bpcMessage.showSuccessMessage({ text: 'global.generic.successful_action' });
    this.i++; // refresh form
    this.$refs.provider.getEntities(); // refresh table
  }

  extendUpdateRowActions(entity: any) {
    entity.actions.sendMessageUsingTemplate.show =
      this.tableIsNotFilteredByTrashedElements() &&
      this.$modulesService.hasModuleActivated(ModulesHelper.COMMUNICATIONS_MODULE_NAME);

    // Add Payment to product
    const canAddPayments = this.$authorizationService.hasPermissionForAction(
      'payments',
      'pay_product',
    );

    entity.actions.payProduct.show =
      this.tableIsNotFilteredByTrashedElements() &&
      canAddPayments &&
      entity.payment_status === 'unpaid' &&
      entity.status !== 'cancelled' &&
      entity.is_multiplayer === false;

    const globalChecksToCancelABooking =
      entity.status !== 'cancelled' && this.tableIsNotFilteredByTrashedElements();

    // const checkPublicCancelConditions =
    const status: string = entity.status;
    const hasNoPayment = entity.booking_event_with_payment === false;
    const bookingOption = this.$authService.getIsIndividual()
      ? entity.booking_options
      : entity.booking_options_for_organization;
    const cancelOptionAllowed = bookingOption?.fixed_options.allow_cancel_booking_event;

    const isNotInThePast =
      moment(`${entity.date} ${entity.start_time}`).diff(moment(), 'minutes') > 0;
    const hasLoadedBookingOptions = !!bookingOption;
    const isNotMultiplayer = !entity.is_multiplayer; // Not managed in this front office

    if (this.isProfileView) {
      // In case we are in the profile sections we check diferent conditions to show the cancel button
      const hasPublicCancelPermission = this.$authorizationService.hasPermissionForAction(
        this.permissionEntityNameToUse ? this.permissionEntityNameToUse : this.pluralEntityName,
        'manage_public_bookings',
        true,
      );

      entity.actions.cancel.activated = hasPublicCancelPermission;
      entity.actions.cancel.show =
        globalChecksToCancelABooking &&
        hasNoPayment &&
        hasLoadedBookingOptions &&
        cancelOptionAllowed &&
        isNotInThePast &&
        isNotMultiplayer &&
        (status === 'draft' || status === 'confirmed');
    } else {
      // When we are not in the profile section
      const hasCancelPermission = this.$authorizationService.hasPermissionForAction(
        this.permissionEntityNameToUse ? this.permissionEntityNameToUse : this.pluralEntityName,
        'cancel',
      );
      const hasCancelOwnPermission = this.$authorizationService.hasPermissionForAction(
        this.permissionEntityNameToUse ? this.permissionEntityNameToUse : this.pluralEntityName,
        'cancel',
        true,
      );
      const hasPublicCancelPermission = this.$authorizationService.hasPermissionForAction(
        this.permissionEntityNameToUse ? this.permissionEntityNameToUse : this.pluralEntityName,
        'manage_public_bookings',
        true,
      );
      const hasManagePermission = this.$authorizationService.hasPermission('manage_bookings');

      // TODO this logic could be simplify but it was like this before
      // and could have some regresions if not applied exactly the same
      entity.actions.cancel.activated =
        hasCancelPermission || hasCancelOwnPermission || hasPublicCancelPermission;

      entity.actions.cancel.show =
        globalChecksToCancelABooking &&
        (status === 'draft' || status === 'confirmed') &&
        (hasManagePermission || (hasNoPayment && cancelOptionAllowed)) &&
        (hasCancelPermission ||
          (hasCancelOwnPermission && isNotInThePast && hasLoadedBookingOptions));
    }
  }

  public headingDate: string = '';

  constructor() {
    super();
  }

  showEvents(eventTime) {
    this.$refs.provider.queryConfig.params.eventTime = eventTime;
    this.$refs.provider.getEntities();
  }

  /* Lifecycle hooks */

  // created() { }
  async mounted() {
    this.exportCheckoutModalId = this.generateUUIDv4();
    this.$root.$on('sector-tabs-loaded', event => {
      this.filterSectorsLoaded = true;
    });
    this.$root.$on('showAlertPrice', event => {
      this.bookingFormModelChanged = true;
    });
    this.$root.$on('bookingEventSaved', event => {
      this.$refs.provider.getEntities();
    });
    if (this.$route.query.showBookingForm) {
      // TO-DO: leave the query as it is instead of setting it to null
      this.$router.replace({ query: null });
      this.onNew();
    }
    this.$root.$on('showBookingForm', event => {
      this.onNew();
    });
    this.$root.$on('refresh-table-after-add-orders-to-pos', () => {
      this.refreshEntitiesAfterOrdersAddedToPosCheckout();
    });
    await this.getAllEvents();

    // For messages with templates
    const templatesRequest = [this.getAllowedTemplatesForSendMessage()];

    Promise.all(templatesRequest).then(res => {
      this.updateRowActions();
      this.updatePageActions();
    });

    this.cancelBookingEventModalId = `booking-event-cancel`;
  }
  // updated () { }
  destroyed() {
    this.$root.$off('showBookingForm');
    this.$root.$off('showAlertPrice');
    this.$root.$off('bookingEventSaved');
    this.$root.$off('refresh-table-after-add-orders-to-pos');
    this.$root.$off('sector-tabs-loaded');
  }

  onBulkCancel() {
    this.showCancelBookingEventModal = true;
  }

  onActionDelete(item) {
    this.$refs.softDeleteConfirmationModal.onOpenModal(item.item['id']);
    this.showBookingDrawerSection = false;
    this.showDrawerSection = false;
  }

  cancelingBookingEvents: boolean = false;
  repetitive: boolean = false;
  repetitiveActionOptionSelected: string = null;
  repetitiveActionOptions: Record<string, any> = [
    {
      text: this.$t('global.modals.update-booking-event.multiple.action_option.options.only'),
      value: 'only_this',
    },
    {
      text: this.$t(
        'global.modals.update-booking-event.multiple.action_option.options.next_same_events',
      ),
      value: 'next_same',
    },
    {
      text: this.$t(
        'global.modals.update-booking-event.multiple.action_option.options.all_same_events',
      ),
      value: 'all_same',
    },
    {
      text: this.$t('global.modals.update-booking-event.multiple.action_option.options.all_events'),
      value: 'cancel_all',
    },
  ];

  /* Refuse booking event */
  showRefuseModal: boolean = false;
  eventIdsToRefuse: string[] | number[] = [];
  eventToRefuseOwnsToRepetitive: boolean = false;
  onActionRefuse(item): void {
    this.eventIdsToRefuse = [item.id];
    this.eventToRefuseOwnsToRepetitive = item.booking?.repetitive || false;
    this.showRefuseModal = true;
  }

  onCloseRefuseModal(): void {
    this.showRefuseModal = false;
    // Reset default data
    this.eventIdsToRefuse = [];
    this.eventToRefuseOwnsToRepetitive = false;
  }

  onSuccessRefuse(): void {
    this.i++;
    this.$refs.provider.getEntities();
  }

  /* Confirm booking event */
  showConfirmModal: boolean = false;
  eventIdsToConfirm: string[] | number[] = [];
  eventToConfirmOwnsToRepetitive: boolean = false;
  onActionConfirm(item): void {
    this.eventIdsToConfirm = [item.id];
    this.eventToConfirmOwnsToRepetitive = item.booking?.repetitive || false;
    this.showConfirmModal = true;
  }

  onCloseConfirmModal(): void {
    this.showConfirmModal = false;
    // Reset default data
    this.eventIdsToConfirm = [];
    this.eventToConfirmOwnsToRepetitive = false;
  }

  onSuccessConfirm(): void {
    this.i++;
    this.$refs.provider.getEntities();
  }

  onCancel(item) {
    this.selectedRowEntity = item.item ? item.item : item;
    this.repetitive = item.item.booking.repetitive === 1 ? true : false;
    this.showBookingDrawerSection = false;
    this.showDrawerSection = false;
    this.showCancelBookingEventModal = true;
  }

  onBookingEventCancel() {
    this.$refs.provider.getEntities();
  }

  onDetailCancel(bookingEventData) {
    this.selectedRowEntity = bookingEventData;
    this.cancelingBookingEvents = false;
    this.repetitiveActionOptionSelected = 'only_this';
    this.$bvModal.hide('booking-detail-modal');
    this.showCancelBookingEventModal = true;
  }

  onCloseModal() {
    this.selectedRowEntity = null;
    this.repetitive = false;
    this.showCancelBookingEventModal = false;
  }

  onPaymentCreated() {
    this.$refs.provider.getEntities();
  }

  syncDateFilterModel(model) {
    console.log('syncFilterModel', model);
    if (model) {
      this.updateHeadingDate(model.date);
    }
  }

  syncSectorFilterModel(model) {
    console.log('syncFilterModel', model);
    if (model) {
      this.$set(model, 'resource__sectors__id', model.resource__sectors__id || null);
    }
  }

  updateHeadingDate(date) {
    this.headingDate = '';
    console.log(date);
    if (date) {
      const locale = this.getLang() === 'be' ? 'fr' : this.getLang();
      this.headingDate = moment(date)
        .locale(locale)
        .format('dddd DD/MM/YYYY')
        .toUpperCase();
    }
  }

  onEdit(e, disabled = false) {
    console.log('clickOnEdit', e);
    this.$bpcStorage.clear('orders');
    this.entity = e.item;
    this.bookingFormModelChanged = false;
    this.showForm = true;
    // this.$bvModal.show('modal-resource-form');
    this.showBookingDrawerSection = false;
    this.showDrawerSection = true;
    setTimeout(() => {
      this.disabledForm = disabled;
    });
  }

  onAddEvent() {
    console.log('clickOnAddEvent');
    this.entity = null;
    this.$bpcStorage.clear('orders');
    console.log('filters', this.filters);
    this.bookingFormModelChanged = false;
    this.showForm = true;
    // this.$bvModal.show('modal-resource-form');
    this.showBookingDrawerSection = false;
    this.showDrawerSection = true;
    this.disabledForm = false;
  }

  onFormClose() {
    this.showForm = false;
    // this.$bvModal.hide('modal-resource-form');
    // this.$refs.provider.getEntities();
    this.showDrawerSection = false;
    this.i++;
    this.showBookingDrawerSection = false;
    // this.isSavingForm = false;
  }

  onFormSaved(event) {
    console.log('onFormSaved is running');
    this.$refs.provider.getEntities();
    this.onFormClose();
    if (this.nextAction === 'pay') {
      const orders = [];
      event.data?.bookingEvents?.forEach(bookingEvent => {
        bookingEvent.orders.forEach(order => orders.push(order));
      });
      this.ordersAvailableToPosCheckout = orders;
      this.selectedOrdersToPosCheckout = orders;
      this.selectedContactIdToPosCheckout = event.data.contact_id;
      this.selectedPriceCategoryIdToPosCheckout = event.data.price_category_id;
      this.selectedInvoiceIdToPosCheckout =
        this.$store.getters['pos/currentTicket']?.status === 'to_pay'
          ? this.$store.getters['pos/currentTicket']
          : null;
      this.openExportPosCheckoutModal();
    }
    this.setNextAction('');
  }

  setNextAction(action) {
    this.nextAction = action;
  }

  /**
   * Functions for booking forms
   */
  onNew() {
    this.entity = null;
    this.showForm = true;
    this.showDrawerSection = false;
    this.showBookingDrawerSection = true;
    this.disabledForm = false;
  }

  getBookingModalTitle() {
    return this.$t('global.modals.create') + ' ' + this.$t('global.models.booking.name');
  }

  /* Calendar events */
  onEventClicked(event) {
    const bookingEvent = event.event;
    if (bookingEvent.classNames.includes('my-event')) {
      this.bookingEventData = this.generateBookingEventData(
        bookingEvent.id,
        moment(bookingEvent.start),
        moment(bookingEvent.end),
        bookingEvent.extendedProps.resource?.id,
        bookingEvent.extendedProps.resource?.name,
        bookingEvent.extendedProps.discipline?.name,
        bookingEvent.extendedProps.isMultiplayer,
        bookingEvent.extendedProps.numberOfPlayers,
      );

      this.selectedRowEntity = this.$refs.provider?.items?.find(
        item => item['id'] == bookingEvent.id,
      );
      this.showBookingEventDetailModal();
    }
  }

  generateBookingEventData(
    id: number,
    start: Moment,
    end: Moment,
    resourceId: number,
    resource: string,
    discipline: string,
    is_multiplayer: boolean,
    number_of_players: number,
  ): PublicBookingEventData {
    return {
      id: id,
      start_time: start.format('HH:mm:ss'),
      date: start.format('YYYY-MM-DD'),
      end_time: end.format('HH:mm:ss'),
      resourceId: resourceId,
      resource: resource,
      discipline: discipline,
      is_multiplayer: is_multiplayer,
      number_of_players: number_of_players,
    };
  }

  showBookingEventDetailModal() {
    this.$bvModal.show('booking-detail-modal');
  }

  onCloseCancelBookingEventModal() {
    this.onCloseModal();
    this.showCancelBookingEventModal = false;
  }

  onCancelBookingEventConfirm() {
    this.onCloseCancelBookingEventModal();
    this.getCurrentContactEvents();
    this.$refs.provider.getEntities();
  }

  onCloseDetailBookingEventModal() {
    this.selectedRowEntity = null;
    this.$bvModal.hide('booking-detail-modal');
  }

  // Confirm bulk edit modal
  confirmUpdateOrderOptions: object[] = [
    {
      text: this.$t('global.modals.update-booking-event.multiple.orders.options.update'),
      value: 'update',
    },
    {
      text: this.$t('global.modals.update-booking-event.multiple.orders.options.no_update'),
      value: 'no_update',
    },
  ];
  confirmUpdateOrderOptionSelected: string = 'update';
  extraDataToBulkEdit: object = {};
  extraFieldsToBulkEdit: object = { defaultValueSwitchModel: {} };
  resetConfirmationUpdateModal() {
    this.confirmUpdateOrderOptionSelected = 'update';
  }

  onFormBulkSave() {
    this.$bvModal.show('confirmation-update-booking-event-modal');
  }

  onConfirmBulkSave() {
    setProp(this.extraFieldsToBulkEdit['defaultValueSwitchModel'], 'update_orders', false);
    setProp(
      this.extraDataToBulkEdit,
      'update_orders',
      this.confirmUpdateOrderOptionSelected === 'update',
    );
    this.$refs.bulkEditModal.saveBulkEdit();
  }

  onFinishBulkEdit() {
    this.$refs.provider.getEntities();
  }

  // Bulk soft delete modal (move to trash)
  showBulkMoveToTrashModal = false;
  onBulkSoftDelete() {
    this.showBulkMoveToTrashModal = true;
  }
  onCLoseBulkSoftDelete() {
    this.showBulkMoveToTrashModal = false;
  }
  onSuccessSoftDelete() {
    this.$refs.softDeleteConfirmationModal.onCloseModal();
    this.$refs.provider.getEntities();
  }

  bulkMoveToTrashDataToShow = [
    ['code', 'resource'],
    ['date', 'start_time', 'end_time'],
    ['contact'],
  ];

  showBulkRecoverModal = false;

  onBulkRecover() {
    this.showBulkRecoverModal = true;
  }

  onCLoseBulkRecover() {
    this.showBulkRecoverModal = false;
  }

  onSuccessBulkRecover() {
    this.$refs.provider.getEntities();
  }

  bulkRecoverDataToShow = [['code', 'resource'], ['date', 'start_time', 'end_time'], ['contact']];

  // Bulk edit modal
  showBulkEditModal = false;
  bulkEditDataToShow = [['code', 'resource'], ['date', 'start_time', 'end_time'], ['contact']];
  onBulkEdit() {
    if (!this.emitOnBulkEdit) {
      this.showBulkEditModal = true;
    } else {
      this.$emit('on-bulk-edit', this.selection);
    }
  }

  onCloseBulkEdit() {
    this.showBulkEditModal = false;
  }

  get blockLoadEntities(): boolean {
    return this.isInput ? false : !this.hideTabsFilter ? !this.filterSectorsLoaded : false;
  }

  @Watch('value')
  updateItemsProvider() {
    if (this.isInput) {
      this.$refs.provider.items = this.value;
      if (this.value) {
        if (this.mode == 'storage') {
          this.$bpcStorage.set(this.pluralEntityName, this.value);
        }
        this.updateRowsActions();
      }
      console.log('change items provider');
    }
  }

  @Watch('selectedDate')
  async onSelectedDateChangeRefreshWeeklyContactBookings() {
    await this.getCurrentContactEvents();
  }
}
